import BlockListingDetail from './BlockListingDetail';
export default BlockListingDetail;
